import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {ReactNode} from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

export default function ErrorMessage({
  className,
  error,
  dataTestAttrs,
}: {
  className?: string;
  error?: string | null | ReactNode;
  dataTestAttrs?: DataTestAttrs;
}): JSX.Element {
  return (
    <div {...getTestProps(dataTestAttrs)} className={classNames('u-danger-color', className)}>
      {error}
    </div>
  );
}

ErrorMessage.propTypes = {
  className: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};
